// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"6b16f816","312":"f8c1e574","497":"1eb491e8","619":"c01e44fe","834":"42b8c18c","848":"8b084bbf","975":"edd32ab0"}[chunkId] + ".chunk.js";
};